import React from 'react';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';
import { useLoad } from '../../collection/Hooks';
import Loading from '../../collection/icons/Loading';

export default function DepartamentoModal(props) {
    const isNew = props.idCliente < 1;

    const updateData = async () => await apiGet("departamentos/get/" + props.idCliente);

    const checkData = formData => {
        let errors = {};
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        // Responsables
        const responsables = formData.get("responsables[]");
        if (!responsables) {
            errors["responsables"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("departamentos/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo departamento" : "Editar departamento"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <DepartamentoForm />
        </BsModalForm>
    );
}

function DepartamentoForm(props) {
    const [listUsuarios, reload] = useLoad(async () => { return await apiGet("usuarios/list") });

    const data = props.data;
    const errors = props.errors;
    return listUsuarios ? <>
        <BsFormControl
            /* Nombre */
            label="Nombre" name="name"
            value={data.name} error={errors.name}
            maxLength="100" />
        <BsFormSelect
            /* Responsables */
            label="Responsables" name="responsables[]"
            value={data.responsables} error={errors.responsables}
            options={listUsuarios}
            className="mt-3" isMulti isClearable />
    </> : <Loading />;
}
